module.exports = __webpack_public_path__ + "assets/img/logo-intella-linepay.e1dc94c9.png";